(($) => {
  $.fn.marqueePlugin = function () {
    const marqueeRows = this;
    let minLogoCount = 1000;
    marqueeRows.each((ind, ele) => {
      const logoCount = $(ele).find('img').length;
      if (minLogoCount > logoCount) {
        minLogoCount = logoCount;
      }
    });
    marqueeRows.each((ind, ele) => {
      const marqueeRow = $(ele);
      const marqueeItems = marqueeRow.find('img');
      marqueeRow.find('>.ct-div-block')
        .append(marqueeItems.clone())
        .addClass('start-marquee');
    });
  };
  $('.moving-logos-wrapper').marqueePlugin();
})(jQuery);

